<!-- Main Tax Attributes: tabs, years table, entity amount details -->
@if (ctx.modalName == 'taxAttribModal') {
<div>
  @if (ctx.taxAttribTabs && ctx.taxAttribTabs.length > 0) {
<ul class="nav nav-pills" role="tablist">
    @for (item of ctx.taxAttribTabs; track $index) {
<li [class.active]="item.TRANS_TYPE_KEY === ctx.activeTab">
      <a (click)="ctx.onTabClick(item)" style="cursor: pointer;" class="btn-sm">
        {{ item.TRANS_TYPE_DESC }}
      </a>
    </li>
}
  </ul>
}

  <div class="tab-content">
    <div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (ctx.showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!ctx.showFormLoader) {
<div>
          @if (ctx.activeTab != 74 && ctx.taxAttribYearsData.length > 0) {
<div class="annualLimit">
            <h4><b>Annual Limit: </b> {{ ctx.taxAttribYearsData[0]?.ANNUAL_382_LIMIT | numberWithCommas }}</h4>
          </div>
}

          <div class="table-no-scroll">
            <table class="table table-bordered form-inline customTable custom-table">
              <thead>
                <tr>
                  <th class="sticky-col">Tax Year</th>
                  <th class="sticky-col">Expire Year</th>
                  <th class="sticky-col">Generated Amount</th>
                  <th class="sticky-col">Expired Amount</th>
                  <th class="sticky-col">Add Utilization</th>
                  <th class="sticky-col">Year Utilized</th>
                  <th class="sticky-col">Amount Utilized</th>
                  <th class="sticky-col">Amount Pre Acquisition</th>
                  <th class="sticky-col">Amount Available</th>
                  @if (ctx.activeTab != 74) {
<th class="sticky-col">382 Limitation Amount</th>
}
                </tr>
              </thead>
              <tbody>
                @for (row of ctx.taxAttribYearsData; track $index) {
<tr class="table1">
                  <td>{{ row.TAX_YEAR }}</td>
                  <td>{{ row.EXPIRE_YEAR }}</td>
                  <td [ngClass]="{'color-red': row.GEN_AMT < 0}">
                    @if (row.TAX_YEAR != null) {
<i class="fa fa-pencil bluepencil pull-left"
                      
                       style="cursor: pointer; margin-top: 4px;"
                       title="Edit NOL Details for {{ row.TAX_YEAR }}"
                       (click)="ctx.openPopUpWindow(row)">
                    </i>
} {{ row.GEN_AMT | numberWithCommas }}
                  </td>
                  <td [ngClass]="{'color-red': row.EXPIRE_AMT < 0}">{{ row.EXPIRE_AMT | numberWithCommas }}</td>
                  <td>
                    @if (row.TAX_YEAR != null) {
<span (click)="ctx.openPopUpWindow(row)">
                      <i style="color: green; font-size: 22px; cursor: pointer;" class="fa fa-plus-circle"></i>
                    </span>
}
                    @if (row.TAX_YEAR == null) {
<span>
                      <i class="fa fa-minus-circle color-red"
                         style="font-size: 22px; cursor: pointer;"
                         title="Remove Utilized Amount"
                         (click)="ctx.deleteUtilAmount(row)">
                      </i>
                    </span>
}
                  </td>
                  <td>{{ row.UTIL_YEAR }}</td>
                  <td [ngClass]="{'color-red': row.UTIL_AMT < 0}">{{ row.UTIL_AMT | numberWithCommas }}</td>
                  <td [ngClass]="{'color-red': row.PREACQUI_AMT < 0}">{{ row.PREACQUI_AMT | numberWithCommas }}</td>
                  <td [ngClass]="{'color-red': row.AVAILABLE_AMT < 0}">{{ row.AVAILABLE_AMT | numberWithCommas }}</td>
                  @if (ctx.activeTab != 74) {
<td [ngClass]="{'color-red': row.ROLLING_ANNUAL_LIMIT < 0}">
                    {{ row.ROLLING_ANNUAL_LIMIT | numberWithCommas }}
                  </td>
}
                </tr>
}
              </tbody>
            </table>
          </div>

          <div class="panel panel-default" style="margin-top: 20px;">
            <div class="panel-heading">
              Entity Amount Details:
              <i class="glyphicon"
                 [ngClass]="{'glyphicon-chevron-down': !ctx.taxAttrsLookUp, 'glyphicon-chevron-up': ctx.taxAttrsLookUp}"
                 style="float: right; cursor: pointer; margin-right: 20px;"
                 (click)="ctx.taxAttrsLookUp = !ctx.taxAttrsLookUp"></i>
            </div>
            @if (ctx.taxAttrsLookUp) {
<div class="panel-body">
              <div class="table-scroll">
                <table class="table table-bordered form-inline customTable custom-table">
                  <thead>
                    <tr>
                      <th class="sticky-col">LEID</th>
                      <th class="sticky-col">Tax Code</th>
                      <th class="sticky-col">Reporting Period</th>
                      <th class="sticky-col">Util Type</th>
                      <th class="sticky-col">Amount</th>
                      <th class="sticky-col">Tax Year</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of ctx.mergedTaxAttribData; track $index) {
<tr class="table1">
                      <td>{{ row.LEID }}</td>
                      <td>{{ row.CDR_NO }}</td>
                      <td>{{ row.REP_PERIOD }}</td>
                      <td>{{ row.UTIL_TYPE }}</td>
                      <td [ngClass]="{'color-red': row.AMT < 0}">{{ row.AMT | numberWithCommas }}</td>
                      <td>{{ row.TAX_YEAR }}</td>
                    </tr>
}
                  </tbody>
                </table>
              </div>
            </div>
}
          </div>
        </div>
}
      </div>
    </div>
  </div>
</div>
}
